<template>
  <div class="container text-center">
    <div class="pt-4 pb-4" >
      <div class="short-rule" v-html="$t('Footer.legalrules')"></div>
    </div>
  </div>
  <footer>
    <div class="container-fluid">
    <div class="navbar">
      <div class="col-sm-12 p-0">
        <ul class="list-inline mb-0" id="footer-nav">
          <li class="list-inline-item">
                <router-link
                  to="/Home"                
                  aria-label="Home"
                  alt="Home"
                  >{{ $t('Footer.Home') }}
                </router-link>
              </li>
              <li class="list-inline-item">
                <router-link
                  to="/ReceiptTroubleshooting"                
                  aria-label="Receipt Troubleshooting"
                  alt="Receipt Troubleshooting"
                  >{{$t('Footer.ReceiptTroubleshooting')}}
                </router-link>
              </li>
        
          <li class="list-inline-item" v-html="$t('Footer.T&CLink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.FAQlink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.ContactUsLink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.CookiePreference')">              
              </li>
          <li class="list-inline-item" v-html="$t('Footer.PrivayPolicyLink')">   
          </li>        
          <li class="list-inline-item" v-html="$t('Footer.USAPrivacyPolicyLink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.TermsOfUseLink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.DNSLink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.AccessibilityLink')">   
          </li>
          <li class="list-inline-item" v-html="$t('Footer.InstaFollowLink')">   
          </li>
        </ul>
        <p class="mt-3 mb-0">
          <span v-html="$t('Footer.copyrighttext')"></span><br /> 
          © {{ new Date().getFullYear() }} {{$t('Footer.AllrightReserved')}}
        </p>
      </div>
    </div>
    </div>
  </footer>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // Append the script to the body
    // document.body.appendChild(script);
  },
};
</script>


